var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forma-pagamento"},[_c('b-card',[_c('b-card-header',[_c('b-card-title',[_vm._v("Forma de Pagamento")])],1),_c('b-card-body',[_c('p',{staticClass:"text-muted"},[_vm._v(" Gerencie suas formas de pagamento. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }